import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  icons: {
    position: 'relative',
    top: '6px',
  },
  columnWidthCheckboxes: {
    width: '80px',
  },
  columnWidth: {
    // width: '330px',
  },
  borderBottom: {
    borderBottom: 'none',
  },
  availabilityFilterLabel: {
    textTransform: 'none',
  },
  availabilityButton: {
    cursor: 'text',
    fontSize: 16,
    color: theme.palette.constrastGreyDark.main,
    height: 40,
    float: 'left',
    marginTop: 10,
    marginBottom: 10,
  },
  divFilters: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& > button': {
      marginRight: '50px',
    },
    '& > div': {
      marginRight: '50px',
    },
  },
  divGroups: {
    marginLeft: '27px',
  },
  divItems: {
    marginLeft: '80px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  floatRight: {
    float: 'right',
  },
  flexColumnCenter: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}));

export default styles;
